import { isNil } from 'lodash';
import { TWorklet } from '../containers/Projects/types';

export const getWorkletNameBySpecURI = (workletSpecUri: string, worklets: TWorklet[]) => {
  if (isNil(worklets) || isNil(workletSpecUri)) return '';
  const selectedWorklet = worklets.find((t) => t.specURI === workletSpecUri);
  return selectedWorklet?.specTitle ?? '';
};
